import Phaser from 'phaser';
import type { Action, GameState } from '../types';
import { reduce } from './reducer';

export type GameEvent = 'change';

export class GameController extends Phaser.Events.EventEmitter {
  private _state: GameState;

  constructor(initial: GameState) {
    super();
    this._state = initial;
  }

  get state(): GameState {
    return this._state;
  }

  dispatch(action: Action): GameState {
    const next = reduce(this._state, action);
    if (next !== this._state) {
      this._state = next;
      this.emit('change', this._state);
    }
    return this._state;
  }

  setState(next: GameState): void {
    this._state = next;
    this.emit('change', this._state);
  }
}
